
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SasLabelValueComponent } from '@shared/sas-label-value/sas-label-value.component';

@Component({
    selector: 'sas-checkbox-field-type',
    standalone: true,
    imports: [ReactiveFormsModule, FormlyModule, TranslateModule, SasLabelValueComponent],
    providers: [],
    template: `
        @if (isShowingSummaryInfo) {
            <sas-label-value [label]="field.props.label ?? ''"
                             [model]="formControl.value ? 'Yes' : 'No'"
                             sasClass="textmode toplabel mb-2">
            </sas-label-value>
        } @else {
            <div class="sas-checkbox mb-3">
                <input type="checkbox"
                       [id]="instanceId"
                       [name]="field.name"
                       [formControl]="formControl"
                       class="form-check-input check"
                       [attr.aria-describedby]="helpText ? instanceId + 'Desc' : ''"
                       [attr.aria-invalid]="field.formControl.invalid || null"
                       [attr.aria-required]="field.props.required || null"
                       (keydown)="onKeydown($event)"
                />
                <label [id]="instanceId + 'Label'"
                       [for]="instanceId"
                       class="form-check-label"
                       translate="{{ field.props.label }}"
                       title="{{ field.props.label ?? '' | translate }}">
                </label>
                @if (helpText?.length && !isReadonly) {
                <div [id]="instanceId + 'Desc'" class="sas-inline-block" [title]="helpText">
                    <i class="bi bi-info-circle-fill" aria-hidden="true" style="font-size: 15px; cursor: help; margin-left: 5px;"></i>
                </div>
                }
            </div>
        }
    `,
    styleUrl: './sas-checkbox-field-type.component.scss'
})

export class SasCheckboxFieldTypeComponent extends FieldType<FieldTypeConfig> {
    private translate = inject(TranslateService);

    instanceId: string = '';
    helpText!: string;
    isShowingSummaryInfo: boolean = false;

    get isReadonly(): boolean {
        return (this.field.formControl.disabled || this.field.props.readonly) ?? false;
    }

    constructor() {
        super()
    }

    ngOnInit() {
        this.instanceId = this.field.id + Math.random().toString(36).substring(2);

        if (this.field.props['helptext']) {
            const helpText = this.translate.instant(this.field.props['helptext']);

            this.helpText = helpText === this.field.props['helptext'] ? '' : helpText;
        }

        this.isShowingSummaryInfo = this.field.props['isShowingSummaryInfo'] ?? false;
    }

    ngDoCheck() {
        if (this.isReadonly && !this.formControl.disabled) {
            this.formControl.disable({ emitEvent: false });
        }

        if (!this.isReadonly && this.formControl.disabled) {
            this.formControl.enable({ emitEvent: false });
        }
    }

    onKeydown(event: KeyboardEvent) {
        if (event.code === 'Enter' || event.key === 'Enter') {
            event.preventDefault();
            if (!this.field.formControl.disabled) {
                this.formControl.setValue(!this.formControl.value);
            }
        }
    }
}
